<template>
    <LayoutSubsidio :imagen="imagen" :titulo="tituloMobile" :items-carrousel="itemsSubsidio"
        :current-index="currentIndex" @atras="atras" @siguiente="siguiente">
        <template #dialogos>
            <DialogoPreAfi ref="refPreAfi" :titulo="titulo" type="nacimiento" />
            <DialogoExito ref="dialogoExito" />
            <DialogoComDistrito ref="dialogoCom" tipo="llamar" />
            <DialogoLlamame ref="llamar" titulo="QUIERO QUE ME LLAMEN" />
        </template>
        <template #form-final>
            <v-card-text class="pt-15">
                <v-form @submit.prevent="submit">
                    <ValidationObserver ref="obs" v-slot="{ invalid }">
                        <v-row class="align-center justify-center">
                            <v-col cols="12" md="9" class="d-flex justify-center">
                                <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                    <v-checkbox v-model="checkbox" :error-messages="v.errors[0]" input-value="false"
                                        value class="mb-5">
                                        <template v-slot:label>
                                            <div
                                                :class="(checkbox) ? `font-weight-medium primary--text` : `black--text font-weight`">
                                                Tengo toda la documentación necesaria.
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12" class="d-flex justify-center">
                                <v-btn type="submit" @keyup.enter="submit" :disabled="invalid" elevation="0"
                                    color="primary" class="pa-6 mb-6" :loading="loading">
                                    <v-icon class="mr-2">mdi-open-in-app</v-icon>
                                    completar formulario
                                </v-btn>
                            </v-col>
                        </v-row>
                    </ValidationObserver>
                </v-form>
            </v-card-text>
        </template>
    </LayoutSubsidio>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import LayoutSubsidio from '@/components/layouts/LayoutSubsidio.vue';
import DialogoPreAfi from '@/components/dialogos/DialogoPreAfi.vue';
import DialogoExito from '@/components/dialogos/DialogoExito.vue';
import DialogoComDistrito from '@/components/dialogos/DialogoComDistrito.vue';
import DialogoLlamame from '@/components/dialogos/DialogoLlamame.vue';
import imgNacimiento from '@/assets/subsidios/img-web-subsidio-nacimiento.jpg';

export default {
    name: 'Nacimiento',
    components: {
        LayoutSubsidio,
        DialogoPreAfi,
        DialogoExito,
        DialogoComDistrito,
        DialogoLlamame,
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            titulo: '',
            tituloMobile: 'SUBSIDIO POR NACIMIENTO',
            imagen: imgNacimiento,
            currentIndex: 0,
            loading: false,
            checkbox: false,
            itemsSubsidio: [
                {
                    tipo: 'requisitos', title: 'REQUISITOS', doble: true,
                    list: ['Plazo de presentación: dentro de los 180 días hábiles de producido el nacimiento',
                        'Contar con doce (12) meses de afiliación ininterrumpida',
                        'Estar al día con el cumplimiento de todas sus obligaciones al momento de la solicitud de la prestación.'],
                },
                { tipo: 'conyuge', title: 'INFORMACIÓN SOBRE EL HIJO/A', doble: true, list: ['Fecha de nacimiento', 'Apellidos y Nombres', 'DNI', 'Sexo'] },
                { tipo: 'documentacion', title: 'DOCUMENTACIÓN  ESCANEADA', doble: false, subtitle: '', list: ['PARTIDA/S DE NACIMIENTO expedida por el Registro de las Personas (acompañar con la hoja adicional de firmas o sello del Registro)', 'Comprobante de CBU'] },
            ],
        };
    },
    computed: {
        ...mapGetters('auth', ['user', 'esActivo', 'tienedeuda']),
        ...mapGetters('subsidios', ['successSubsidio', 'validAportesPagos', 'validPlanPagos']),
    },
    watch: {
        successSubsidio(newVal) {
            if (newVal === true) {
                this.$refs.dialogoExito.abrirDialog();
            }
        },
    },
    mounted() {
        window.scrollTo(0, -50);
    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),

        submit() {
            const vm = this;
            this.$refs.obs.validate().then(result => {
                if (result && !this.tienedeuda && this.esActivo && this.validAportesPagos && this.validPlanPagos) {
                    vm.titulo = 'Solicitud de subsidio por nacimiento';
                    vm.$refs.refPreAfi.abrirDialogo();
                } else {
                    vm.$refs.dialogoCom.abrirDialog().then(result => {
                        if (result) this.$refs.llamar.abrirDialogo();
                    });
                }
            });
        },
        siguiente() {
            if (this.currentIndex < this.itemsSubsidio.length) {
                this.currentIndex++;
            }
        },
        atras() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
            } else {
                this.$router.push('/Subsidios').catch(() => { });
            }
        },
        goToHome() {
            this.$router.push('/subsidios').then(() => {
                location.reload();
            });
        },
    },
};
</script>
